import { FlexRow } from '@epam/loveship'
import { cx } from '@epam/uui-core'
import { useAppSelector } from '../../../../hooks/redux/redux'
import { useIsFirstSidebarMount } from '../../../../hooks/useIsFirstSidebarMount'
import css from './MenuBar.module.scss'

type MenuBarProps = {
  children: React.ReactChild | React.ReactChild[] | null
  position?: 'topLeft' | 'bottomLeft'
}

export const MenuBar = ({ children, position = 'topLeft' }: MenuBarProps) => {
  const { isSideBarOpened, isSideBarGoingToClose } = useAppSelector(
    (state) => state.app
  )
  const isFirstMount = useIsFirstSidebarMount(isSideBarOpened)

  const className = cx(
    css.menuBar,
    css[position],
    { show: isSideBarOpened && !isFirstMount },
    { hide: isSideBarGoingToClose && !isFirstMount }
  )

  return (
    <FlexRow spacing="12" cx={className}>
      {children}
    </FlexRow>
  )
}
